import { cn } from "../../utils/cn.ts";
import { motion, MotionValue } from "framer-motion";
import React from "react";
import { Link } from 'react-router-dom';

const transition = {
  duration: 0,
  ease: "linear",
};

export const GoogleGeminiEffect = ({
  pathLengths,
  title,
  description,
  className,
}: {
  pathLengths: MotionValue[];
  title?: string;
  description?: string;
  className?: string;
}) => {
  return (
    <div className={cn("sticky top-40", className)}>
      <p className="text-[45px] md:text-7xl font-normal pt-16 text-center bg-clip-text text-transparent bg-gradient-to-b from-neutral-100 to-neutral-300">
        {`aniplay.`}
      </p>
      <p className="text-[20px] md:text-xl font-normal text-center text-neutral-400 mt-4 max-w-lg mx-auto">
        {description ||
          `HLS Powered Video Streaming Platform for Anime Lovers`}
      </p>
      <div className="w-full h-[890px] -top-60 md:-top-40  flex items-center justify-center bg-red-transparent absolute z-50">
      <Link to="/home">
        <button onClick={() => console.log("Button clicked")}  className="font-bold scale-125 hover:scale-140 transition bg-white rounded-full md:px-4 md:py-2 px-2 py-1 md:mt-24 mt-8 z-9999 md:text-base text-black text-xs  w-fit mx-auto ">
          Enter
        </button>
        </Link>
      </div>
    </div>
  );
};
